import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo and Description */}
          <div>
            <a href="/" className="flex items-center gap-3 mb-5 cursor-pointer group">
              <div className="w-11 h-11 flex items-center justify-center bg-gradient-to-br from-red-600 to-red-700 rounded-xl shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                <i className="ri-fire-fill text-white text-xl"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-white leading-none">
                  YANGINALGILA
                </span>
                <span className="text-base font-semibold text-red-400 leading-none">.com</span>
              </div>
            </a>
            <p className="text-gray-300 leading-relaxed max-w-sm">
              Yangın algılama ve söndürme sistemlerinde 15 yıllık deneyim. Güvenliğiniz bizim önceliğimiz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Hızlı Bağlantılar</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Hizmetlerimiz
                </Link>
              </li>
              <li>
                <Link to="/sss" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Sık Sorulan Sorular
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Hizmetlerimiz</h3>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Yangın Algılama Sistemleri</li>
              <li className="text-gray-400 text-sm">Duman Dedektörleri</li>
              <li className="text-gray-400 text-sm">Isı Sensörleri</li>
              <li className="text-gray-400 text-sm">Yangın Alarm Sistemleri</li>
              <li className="text-gray-400 text-sm">Bakım ve Onarım</li>
              <li className="text-gray-400 text-sm">Proje Danışmanlığı</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">İletişim</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/5 flex-shrink-0">
                  <i className="ri-map-pin-line text-red-400"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Konutkent Mahallesi 3028 Cadde<br />
                    Elmar Towers C Blok No:17<br />
                    Çankaya/Ankara
                  </p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/5 flex-shrink-0">
                  <i className="ri-phone-line text-red-400"></i>
                </div>
                <a href="tel:+903126660636" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  0312 666 06 36
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/5 flex-shrink-0">
                  <i className="ri-mail-line text-red-400"></i>
                </div>
                <a href="mailto:info@yanginalgila.com" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  info@yanginalgila.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} yangınalgıla.com - Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-gray-400 text-sm">CE Sertifikalı</span>
              <span className="text-gray-400 text-sm">TSE Onaylı</span>
              <span className="text-gray-400 text-sm">ISO 9001</span>
            </div>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
